import React, { FC } from 'react';
import { MButtonAppProps } from './MButtonApp.types';
import * as Styled from './MButtonApp.styles';

const COMPONENT_NAME = 'm-web-ui-kit-MButtonApp';
const TEST_ID = 'web-ui-kit-MButtonApp';

export const MButtonApp: FC<MButtonAppProps> = ({ children, onClick, type, href, className, style, ...rest }) => {
  const content = children ?? <Styled.Label>{type}</Styled.Label>;

  const commonProps = {
    'data-component-name': COMPONENT_NAME,
    'data-testid': TEST_ID,
    className,
    style,
    onClick: onClick as React.MouseEventHandler<HTMLButtonElement | HTMLAnchorElement>,
    ...rest,
  };

  if (href) {
    return (
      <Styled.Link href={href} {...commonProps}>
        {content}
      </Styled.Link>
    );
  }

  return (
    <Styled.Button type="button" {...commonProps}>
      {content}
    </Styled.Button>
  );
};
